import { Button, IconLucide } from '@yakit/ui-components';

import { useVDLStore } from '@VDL/store/VDLstore';
import type { ComponentProps } from 'react';

export const VDLToggleSidebarButton = ({
  ...props
}: ComponentProps<typeof Button>) => {
  const { sidebarExpanded, setSidebarExpanded } = useVDLStore();

  return (
    <Button
      className={props.className}
      size="icon"
      variant="outline"
      onClick={() => setSidebarExpanded(!sidebarExpanded)}
    >
      <IconLucide name="PanelsTopLeft" className="h-4 w-4" />
    </Button>
  );
};
